import { render, staticRenderFns } from "./InboundSMSList.vue?vue&type=template&id=395cb642&"
import script from "./InboundSMSList.vue?vue&type=script&lang=js&"
export * from "./InboundSMSList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports